export default __webpack_public_path__ + "static/media/plus.66dd51ed.svg";